import { ReactElement } from "react";
import { ILadleData } from "../types";
import { formatDateTimeWithSeconds } from "../../../../system/utils";

interface ILadleTrackingProps {
  ladleData: ILadleData;
}


const LadleTracking = ({ ladleData }: ILadleTrackingProps): ReactElement => {

  return (
    <div className="display-flex-row align-items-stretch border-bottom alternate-color " >
      <div className="flex-grow-0 p-1 display-flex-column align-self-stretch align-items-center justify-content-center" style={{ background: ladleData.color, width: 120 }}>
        <strong style={{ fontSize: "2em" }}>{ladleData.ladle}</strong>
        <strong>{ladleData.heatNumber}</strong>
        <strong>{ladleData.steelCode}</strong>
      </div>
      <div className="m-1 display-flex-column p-1" style={{ width: 100 }}>
        <strong>Machine</strong>
        <strong>Begin</strong>
        <strong>End</strong>
        <strong>Status</strong>
        <strong>Temperature</strong>
        <strong>Weight</strong>
      </div>
      <div className="flex-grow-1 p-1 display-flex-row">
        {ladleData.tracking.map((tracking, index) => {

          return (
            <div className="m-1 display-flex-column mr-4" key={`ladle-tracking-${ladleData.heatNumber}-${index}`} style={{ width: 200 }}>
              <strong className="text-center" style={{ background: "#b0bec5" }}>{tracking.machineName}</strong>
              <strong>{formatDateTimeWithSeconds(tracking.beginDatetime)}</strong>
              <strong>{formatDateTimeWithSeconds(tracking.endDatetime)}</strong>
              <strong className="text-right">{tracking.status}</strong>
              <strong className="text-right">{tracking.temperature}</strong>
              <strong className="text-right">{tracking.weight ?? "---"}</strong>
            </div>
          );
        })
        }
      </div>
    </div>
  );
};

export default LadleTracking;
